/* Falta brands listing behaviour
   Call window.faltaInitBrands(sectionId) once per section instance.

   ORDER BEATS BALANCE. Appended cards used to go to whichever column was
   currently shortest. Column height is driven by image height, so that is
   literally sorting the portfolio by aspect ratio: a page two card with a tall
   cover would land above one published a year later. Cards are now placed
   round robin on a running index, so reading left to right, top to bottom, is
   always newest to oldest.

   The columns end up slightly uneven as a result. That is the correct trade:
   a ragged bottom edge is a cosmetic issue, a portfolio in the wrong order is
   not.

   THE REGRID EVENT. Rebuilding the masonry detaches every card and puts it
   back. Detaching a <video> pauses it, and because removal and re-insertion
   happen in the same tick the IntersectionObserver never sees an intermediate
   state, so nothing restarts them and every card video freezes on its first
   frame. The grid announces rebuilds and the video module replays what is on
   screen.

   THE HERO is never evicted and never counted against the playback cap.
   SIDEBAR THUMBNAILS belong to assets/falta-sidebar.js, not here. */

window.faltaInitBrands = function (sectionId) {
  var section = document.querySelector('section.brands-layout[data-section-id="' + sectionId + '"]');
  if (!section) return;

  var KEY = '__faltaBrandsInit_' + sectionId;
  if (window[KEY]) return;
  window[KEY] = true;

  /* ================= CLOCK ================= */

  (function () {
    var card = document.getElementById('brands-clock-card');
    if (!card) return;

    var dateEl = document.getElementById('brands-clock-date');
    var timeEl = document.getElementById('brands-clock-time');
    var cityEl = document.getElementById('brands-clock-city');

    var zones = [
      { id: 'Asia/Dubai', label: 'Dubai' },
      { id: 'Europe/Paris', label: 'Paris' },
      { id: 'America/New_York', label: 'New York' },
      { id: 'Australia/Sydney', label: 'Sydney' },
      { id: 'Asia/Shanghai', label: 'Shanghai' }
    ];

    var index = 0;

    function updateClock() {
      var zone = zones[index];
      var now = new Date();
      if (dateEl) dateEl.textContent = now.toLocaleDateString('en-GB', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
      if (timeEl) timeEl.textContent = now.toLocaleTimeString('en-US', { timeZone: zone.id, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
      if (cityEl) cityEl.textContent = zone.label;
    }

    updateClock();
    setInterval(updateClock, 1000);
    card.addEventListener('click', function () { index = (index + 1) % zones.length; updateClock(); });
  })();

  /* ================= MASONRY ================= */

  var masonry = (function () {
    var grid = section.querySelector('.brands-grid');
    if (!grid) return null;

    var columns = [];
    var current = 0;
    var placed = 0;   // running index, so appends continue the sequence

    function wanted() {
      var w = window.innerWidth;
      if (w >= 1400) return 3;
      if (w >= 990) return 2;
      return 1;
    }

    // Round robin on the running index. Deliberately not shortest column:
    // shortest column sorts by height, and height is aspect ratio.
    function place(card) {
      if (!columns.length) { grid.appendChild(card); placed++; return; }
      columns[placed % columns.length].appendChild(card);
      placed++;
    }

    function announce() {
      try { section.dispatchEvent(new CustomEvent('falta:regrid')); } catch (e) {}
    }

    function distribute(force) {
      var n = wanted();
      if (!force && n === current && columns.length === n) return;

      var cards = Array.prototype.slice.call(grid.querySelectorAll('.brands-card'));
      current = n;
      columns = [];
      placed = 0;
      grid.innerHTML = '';
      grid.style.setProperty('--cols', String(n));

      if (n === 1) {
        grid.classList.remove('is-columned');
        for (var i = 0; i < cards.length; i++) { grid.appendChild(cards[i]); placed++; }
        report(cards.length, n);
        announce();
        return;
      }

      grid.classList.add('is-columned');

      for (var c = 0; c < n; c++) {
        var col = document.createElement('div');
        col.className = 'brands-grid__col';
        grid.appendChild(col);
        columns.push(col);
      }

      for (var j = 0; j < cards.length; j++) place(cards[j]);

      report(cards.length, n);
      announce();
    }

    function report(total, n) {
      if (!window.console || !console.info) return;
      var counts = [];
      for (var i = 0; i < columns.length; i++) counts.push(columns[i].querySelectorAll('.brands-card').length);
      console.info(
        '[Falta grid] viewport', window.innerWidth + 'px',
        '| tracks', n,
        '| cards', total,
        '| per column', counts.length ? counts.join(', ') : total,
        '| grid width', Math.round(grid.getBoundingClientRect().width) + 'px'
      );
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { distribute(false); }, 200);
    });

    distribute(true);

    return { place: place, grid: grid, distribute: distribute, announce: announce };
  })();

  /* ================= INFINITE SCROLL ================= */

  (function () {
    var root = section.querySelector('.brands-infinite');
    if (!root) return;

    var sentinel = root.querySelector('.brands-infinite__sentinel');
    var pagination = root.querySelector('.brands-pagination');
    if (pagination) pagination.style.display = 'none';

    var nextUrl = root.dataset.nextUrl;

    if (!nextUrl) {
      if (window.console) console.info('[Falta grid] no further pages, all cards are on this one');
      return;
    }

    var loading = false;
    var observer = null;

    function loadMore() {
      if (!nextUrl || loading) return;
      loading = true;

      fetch(nextUrl)
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newRoot = doc.querySelector('.brands-infinite');
          if (!newRoot) { nextUrl = ''; if (observer) observer.disconnect(); return; }

          var incoming = newRoot.querySelectorAll('.brands-card');
          for (var i = 0; i < incoming.length; i++) if (masonry) masonry.place(incoming[i]);
          if (window.console) console.info('[Falta grid] appended', incoming.length, 'cards in order');

          nextUrl = newRoot.dataset.nextUrl || '';
          root.dataset.nextUrl = nextUrl;
          if (!nextUrl && observer) observer.disconnect();
          if (masonry) masonry.announce();
        })
        .catch(function (e) {
          if (window.console) console.error('[Falta grid] infinite scroll failed', e);
          if (observer) observer.disconnect();
        })
        .then(function () { loading = false; });
    }

    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) loadMore();
    }, { rootMargin: '400px 0px 0px 0px' });

    if (sentinel) observer.observe(sentinel);
  })();

  /* ================= LAZY AUTOPLAY VIDEO ================= */

  (function () {
    var isIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !window.MSStream;

    var ROOT_MARGIN = isIOS ? '150px 0px' : '250px 0px';
    var MAX_PLAYING = isIOS ? 3 : 6;

    var playingOrder = [];

    function isHero(v) { return !!(v && v.closest && v.closest('.brands-layout__hero')); }
    function isSidebar(v) { return !!(v && v.closest && v.closest('.fsb')); }
    function getShell(el) { return el.closest('.js-media-shell') || el.parentElement; }

    function markLoading(shell) {
      if (!shell) return;
      shell.classList.add('is-loading');
      shell.classList.remove('is-loaded');
    }

    function markLoaded(shell) {
      if (!shell) return;
      shell.classList.remove('is-loading');
      shell.classList.add('is-loaded');
    }

    function prepareVideo(v) {
      if (!v) return;
      v.muted = true;
      v.defaultMuted = true;
      v.loop = true;
      v.playsInline = true;
      v.autoplay = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('autoplay', '');
    }

    function ensureSrc(v) {
      if (!v) return;
      var src = v.getAttribute('data-src');
      if (!src) return;
      if (v.getAttribute('src') || v.currentSrc) return;
      try { v.setAttribute('src', src); v.preload = 'metadata'; v.load(); } catch (e) {}
    }

    function pause(v) { if (v) { try { v.pause(); } catch (e) {} } }

    function markPlaying(v) {
      if (isHero(v)) return;

      var i = playingOrder.indexOf(v);
      if (i !== -1) playingOrder.splice(i, 1);
      playingOrder.push(v);

      while (playingOrder.length > MAX_PLAYING) {
        var victim = playingOrder.shift();
        if (victim && victim !== v) pause(victim);
      }
    }

    function bindLoaded(shell, v) {
      if (!v || v.__loadedBound) return;
      v.__loadedBound = true;
      ['loadedmetadata', 'playing', 'canplay', 'loadeddata', 'error'].forEach(function (evt) {
        v.addEventListener(evt, function () { markLoaded(shell); }, { once: true });
      });
    }

    function safePlay(v) {
      if (!v) return;
      var shell = getShell(v);

      prepareVideo(v);
      ensureSrc(v);
      bindLoaded(shell, v);

      try {
        if (v.readyState >= 1) markLoaded(shell); else markLoading(shell);
      } catch (e) { markLoading(shell); }

      var p = null;
      try { p = v.play(); } catch (e) { p = null; }
      if (p && typeof p.then === 'function') p.then(function () { markPlaying(v); }).catch(function () {});
      else markPlaying(v);
    }

    function observeImages(ctx) {
      var imgs = (ctx || section).querySelectorAll('img.js-blur-img');
      for (var i = 0; i < imgs.length; i++) {
        (function (img) {
          var shell = getShell(img);
          if (!shell) return;
          if (img.complete) { markLoaded(shell); return; }
          markLoading(shell);
          img.addEventListener('load', function () { markLoaded(shell); }, { once: true });
          img.addEventListener('error', function () { markLoaded(shell); }, { once: true });
        })(imgs[i]);
      }
    }

    var videoIO = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var v = entries[i].target;
            v.__isVisible = entries[i].isIntersecting;
            if (entries[i].isIntersecting) safePlay(v);
            else pause(v);
          }
        }, { root: null, rootMargin: ROOT_MARGIN, threshold: 0.1 })
      : { observe: function (v) { safePlay(v); } };

    var watched = new WeakSet();

    function observeVideos(ctx) {
      var vids = (ctx || section).querySelectorAll('video.js-lazy-autoplay');
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i];
        if (isSidebar(v)) continue;
        if (watched.has(v)) continue;
        watched.add(v);

        prepareVideo(v);
        try { if (v.readyState >= 1) markLoaded(getShell(v)); } catch (e) {}
        videoIO.observe(v);
      }
    }

    function resumeVisible() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var all = section.querySelectorAll('video.js-lazy-autoplay');
      var started = 0;

      for (var i = 0; i < all.length; i++) {
        var v = all[i];
        if (isSidebar(v)) continue;
        if (!v.paused) continue;

        var r = v.getBoundingClientRect();
        if (r.bottom <= -200 || r.top >= vh + 200) continue;

        safePlay(v);
        started++;
      }

      if (started && window.console) console.info('[Falta grid] resumed', started, 'videos after rebuild');
    }

    observeImages(section);
    observeVideos(section);

    section.addEventListener('falta:regrid', function () {
      requestAnimationFrame(function () { requestAnimationFrame(resumeVisible); });
    });

    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (!added[j] || added[j].nodeType !== 1) continue;
          observeImages(added[j]);
          observeVideos(added[j]);
        }
      }
    }).observe(section, { childList: true, subtree: true });

    window.addEventListener('load', function () { setTimeout(resumeVisible, 900); });
    document.addEventListener('touchstart', resumeVisible, { once: true, passive: true });
    document.addEventListener('pointerdown', resumeVisible, { once: true, passive: true });
  })();
};
